import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Particle from "../Particle";
import levelTwoImg from "../../freelancing refrence/level TWO.jpg";
import fiverrReviewsImg from "../../freelancing refrence/reviews.jpg";
import reviewOneImg from "../../freelancing refrence/review one.PNG";
import reviewTwoImg from "../../freelancing refrence/review two.PNG";

function Reviews() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container style={{ position: "relative", zIndex: 1 }}>
        <h1 className="project-heading" style={{ paddingBottom: "30px" }}>
          Client <strong className="purple">Reviews & Achievements</strong>
        </h1>

        {/* Fiverr Level 2 Seller Achievement */}
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Col md={10} lg={8}>
            <Card className="quote-card-view" style={{ padding: "20px" }}>
              <h2 style={{ color: "#c770f0", textAlign: "center", marginBottom: "20px" }}>
                🏆 Fiverr Level 2 Seller Achievement
              </h2>
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <img
                  src={levelTwoImg}
                  alt="Fiverr Level 2 Seller Badge"
                  style={{ 
                    maxWidth: "100%", 
                    height: "auto",
                    borderRadius: "10px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)"
                  }}
                />
              </div>
              <p style={{ textAlign: "center", marginTop: "20px", color: "rgb(155 126 172)", fontSize: "1.1em" }}>
                Recognized as a Level 2 Seller on Fiverr with 40+ successful projects and outstanding client satisfaction.
              </p>
            </Card>
          </Col>
        </Row>

        {/* Fiverr Client Reviews - Scrollable */}
        <h2 className="project-heading" style={{ paddingBottom: "30px" }}>
          <strong className="purple">Fiverr</strong> Client Reviews
        </h2>

        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Col md={10} lg={8}>
            <Card className="quote-card-view" style={{ padding: "20px" }}>
              <h3 style={{ color: "#c770f0", marginBottom: "20px", textAlign: "center" }}>
                Client Testimonials from Fiverr
              </h3>
              <div 
                style={{ 
                  maxHeight: "600px", 
                  overflowY: "auto", 
                  overflowX: "hidden",
                  borderRadius: "10px",
                  padding: "10px",
                  backgroundColor: "rgba(0, 0, 0, 0.2)"
                }}
              >
                <img
                  src={fiverrReviewsImg}
                  alt="Fiverr Client Reviews"
                  style={{ 
                    width: "100%", 
                    height: "auto",
                    display: "block",
                    borderRadius: "5px"
                  }}
                />
              </div>
              <p style={{ textAlign: "center", marginTop: "15px", color: "rgb(155 126 172)", fontSize: "0.95em" }}>
                Scroll to view all Fiverr reviews
              </p>
            </Card>
          </Col>
        </Row>

        {/* Upwork Client Reviews Section */}
        <h2 className="project-heading" style={{ paddingBottom: "30px" }}>
          <strong className="purple">Upwork</strong> Client Testimonials
        </h2>

        {/* Review One - Scrollable */}
        <Row style={{ justifyContent: "center", paddingBottom: "30px" }}>
          <Col md={10} lg={8}>
            <Card className="quote-card-view" style={{ padding: "20px" }}>
              <h3 style={{ color: "#c770f0", marginBottom: "20px", textAlign: "center" }}>
                Client Review #1
              </h3>
              <div 
                style={{ 
                  maxHeight: "600px", 
                  overflowY: "auto", 
                  overflowX: "hidden",
                  borderRadius: "10px",
                  padding: "10px",
                  backgroundColor: "rgba(0, 0, 0, 0.2)"
                }}
              >
                <img
                  src={reviewOneImg}
                  alt="Upwork Client Review 1"
                  style={{ 
                    width: "100%", 
                    height: "auto",
                    display: "block",
                    borderRadius: "5px"
                  }}
                />
              </div>
              <p style={{ textAlign: "center", marginTop: "15px", color: "rgb(155 126 172)", fontSize: "0.95em" }}>
                Scroll to view full review
              </p>
            </Card>
          </Col>
        </Row>

        {/* Review Two - Scrollable */}
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Col md={10} lg={8}>
            <Card className="quote-card-view" style={{ padding: "20px" }}>
              <h3 style={{ color: "#c770f0", marginBottom: "20px", textAlign: "center" }}>
                Client Review #2
              </h3>
              <div 
                style={{ 
                  maxHeight: "600px", 
                  overflowY: "auto", 
                  overflowX: "hidden",
                  borderRadius: "10px",
                  padding: "10px",
                  backgroundColor: "rgba(0, 0, 0, 0.2)"
                }}
              >
                <img
                  src={reviewTwoImg}
                  alt="Upwork Client Review 2"
                  style={{ 
                    width: "100%", 
                    height: "auto",
                    display: "block",
                    borderRadius: "5px"
                  }}
                />
              </div>
              <p style={{ textAlign: "center", marginTop: "15px", color: "rgb(155 126 172)", fontSize: "0.95em" }}>
                Scroll to view full review
              </p>
            </Card>
          </Col>
        </Row>

        {/* Call to Action */}
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Col md={10} lg={8} style={{ textAlign: "center" }}>
            <h3 style={{ color: "#c770f0", marginBottom: "20px" }}>
              Ready to Work Together?
            </h3>
            <p style={{ color: "white", fontSize: "1.1em", lineHeight: "1.8" }}>
              Join 50+ satisfied clients who have trusted Cyborg Solution to build ERP, CRM, SaaS, and AI automation platforms.
              <br />
              Schedule a consultation or message us to discuss your roadmap.
            </p>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Reviews;
